
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { TokenMetadata } from '../lib/pinata';

export enum RankTier {
  DIAMOND = 'DIAMOND',
  GOLD = 'GOLD',
  SILVER = 'SILVER',
  BRONZE = 'BRONZE',
  UNRANKED = 'UNRANKED'
}

export interface RankingMetrics {
  marketCap: number;
  volume24h: number;
  liquidity: number;
  holders: number;
  trustScore: number; // 0-100 derived from static analysis
  ageHours: number;
}

export interface RankedToken {
  token: TokenMetadata;
  rank: number;
  score: number; // Composite score 0-1000
  tier: RankTier;
  metrics: RankingMetrics;
  trend: 'UP' | 'DOWN' | 'STABLE';
}
